
import { AbstractControl, AsyncValidatorFn, ValidationErrors} from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SharedService } from 'src/app/services/shared.service';

  export class PrePasswordValidator {
    static createValidator(sharedService: SharedService): AsyncValidatorFn {
      return (control: AbstractControl): Observable<ValidationErrors> => {
        return sharedService
          .checkOldPassword(control.value)
          .pipe(
            map((result: any) =>{
              if(result.pwdExist){ 
                return {pwdexist: true}
              }else{
                return null
              } 
            })
          );
      };
    }
  }